import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { agentsServices } from '@services';

import { QUERY_KEYS } from 'constants/queryKeys';
import { getAgentsRequestPayload, handleAgentsData } from './utils';

export const AGENTS_PAGE_SIZE = 1000;

export const useAgentsOperations = () => {
  const router = useRouter();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || AGENTS_PAGE_SIZE;
  const query = router.query?.query;
  const role = router.query?.role;

  const params = {
    page,
    pageSize: parseInt(pageSize, 10) || AGENTS_PAGE_SIZE,
    role,
  };

  const urlParams = {
    page,
    pageSize: parseInt(pageSize, 10) || AGENTS_PAGE_SIZE,
    query,
  };

  const cleanParams = getCleanedUrlParams(params);

  const cleanUrlParams = getCleanedUrlParams(urlParams);

  const agentResponse = useQuery(
    [QUERY_KEYS.GET_AGENTS_KEY, cleanParams, cleanUrlParams],
    () => {
      const payload = getAgentsRequestPayload(cleanParams);

      return agentsServices.getFilterAgents({
        params: cleanUrlParams,
        payload,
      });
    }
  );

  useEffect(() => {
    if (agentResponse?.error) {
      showError(agentResponse?.error);
    }
  }, [agentResponse?.error]);

  return {
    page,
    total: agentResponse?.data?.meta?.total,
    error: agentResponse?.error,
    isSuccess: agentResponse?.isSuccess,
    loading: agentResponse?.isLoading,
    pageSize: parseInt(pageSize, 10) || AGENTS_PAGE_SIZE,
    agents: handleAgentsData(agentResponse?.data?.data),
    refresh: agentResponse.refetch,
  };
};
